import * as React from "react";
import {makeStyles} from "@mui/styles";

type HasChildren = {
   children: React.ReactNode | React.ReactNode[] | null;
}

export const InfoStepper = (props: HasChildren) => {
   const classes = useStyles();
   return <div className={classes.container}>
      {props.children}
   </div>
}

const useStyles = makeStyles({
   container: {
      boxSizing: 'border-box'
   }
})